import React from 'react';
import Popup from './Popup';
import {Modal} from 'semantic-ui-react';
import {connect} from 'react-redux';
import './popup.scss';

export default connect(
	state => ({modal: state.modal}),
	dispatch => ({
		close: () => dispatch({type: 'SET_MODAL'})
	})
)((props) => {
	const {modal} = props;
	return modal && (
		<Popup>
			<Modal open closeIcon onClose={props.close} className="cfz-popup">
				<Modal.Header>{modal.name}</Modal.Header>
				<Modal.Content>
					<div className='image-container'>
						<img src={modal.src} className='image-scroll'/>
					</div>
				</Modal.Content>
			</Modal>
		</Popup>
	);
});


// WEBPACK FOOTER //
// ./src/modules/Popup/index.js